import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ErrorService } from '@app/common/services/error.service';
import { PlexEnvironment } from '@app/env';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MappingSchedule } from '../../models/mapping-schedule';

@Injectable()
export class FindProjectScheduleService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);
  public environment = inject(PlexEnvironment);

  private baseUrl: string;

  constructor() {
    this.baseUrl = this.environment.apiUrl;
  }

  getScheduleCandidateForProject(projectId: number): Observable<MappingSchedule[]> {
    const queryString = `${this.baseUrl}ProjectsCustom/GetScheduleCandidateForProject?projectId=${projectId}`;
    return this.http.get<MappingSchedule[]>(queryString).pipe(
      map((response: MappingSchedule[]) => response),
      catchError(error => this.handleErrorObservable(error, 'Error getting candidate schedules')),);
  }

  updateSchedule(projectId: number, scheduleId: number): Observable<any> {
    const queryString = `${this.baseUrl}ProjectsCustom/UpdateProjectScheduleId`;
    const body = { projectId: projectId, scheduleId: scheduleId };

    return this.http.post(queryString, body).pipe(
      catchError(error => this.handleErrorObservable(error, 'Error Saving Project')),);
  }

  private handleErrorObservable(error: object | any, message: string) {
    this.errorService.error(message, error);
    return throwError(error.message || error);
  }
}